import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import 'bootstrap/dist/css/bootstrap.css';
import { I18n } from 'react-i18next';
import * as d3 from 'd3v4';
// import * as IframeResizer from 'iframe-resizer';

import VizCalendario from './componentes/VizCalendario';
import i18n from './i18n';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlBase: null
    };
  }

  render() {
    const urlBase = this.state.urlBase;
    if (urlBase) {
      return (
        <I18n ns="translations">
          {(t, { i18n }) => <VizCalendario t={t} i18n={i18n} urlBase={urlBase} />}
        </I18n>
      );
    } else {
      return <div />;
    }
  }
  componentDidMount() {
    let urlBase = `https://golyfutbol-widget-data.s3.amazonaws.com/calendario-copa-mundo`;
    // let urlBase = `./`;
    this.setState({ urlBase: urlBase });
    // window.addEventListener('message', this.receiveMessage.bind(this), false);
  }
  ifIsAuthorizedOrigin(event, authorizedCallback) {
    if (!event.origin) return;
    let domainPattern = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/im;
    let domain = domainPattern.exec(event.origin)[1];
    console.log(`CHECKING: ${domain}`);
    let authorizationUrl = `https://golyfutbol-widget-auth.s3.amazonaws.com/calendario-copa-mundo/${domain}`;
    // const reqOrigenes =
    d3.text(authorizationUrl, (error, data) => {
      if (error || data.length <= 0) {
        throw new Error('Origin not authorized.');
      } else {
        console.log(`AUTHORIZED: ${domain}`);
        authorizedCallback(event);
      }
    });
  }
  receiveMessage(event) {
    // Validar contenido del mensaje.
    if (!(event.data && event.data.messageType === 'iframe-data')) return;
    this.ifIsAuthorizedOrigin(event, () => {
      // Armar URL a partir del id de liga que llegó.
      let urlBase = `https://golyfutbol-widget-data.s3.amazonaws.com/calendario-copa-mundo`;
      this.setState({ urlBase: urlBase });
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js